<template>
  <div class="footer-bottom">
    <div class="container">
      <ul>
        <!--        <li><a href="#">Privacy Policy</a></li>-->
        <!--        <li><a href="#">Refund Policy</a></li>-->
        <!--        <li><a href="#">Cookie Policy</a></li>-->
        <!--        <li><a href="#">Terms & Conditions</a></li>-->
      </ul>
      <div class="footer-copyright">
        <p>
          &copy; {{ new Date().getFullYear() }}
          {{ config.name }}
          {{ 'All Rights Reserved.' }}
        </p>
        <back-to-top/>
      </div>
      <div class="text-center mt-2 pb-4">
        <p style="text-transform: uppercase;color: #999;font-size: 0.7em;">Powered by</p>
        <a href="http://zozu.pl">
          <img style="max-width: 120px;"
               src="/media/assets/images/zozu/logo_horizontal_black.png"
               class="navbar-brand" alt="Zozu.pl - Pełne wsparcie obsługi restauracji">
        </a>
        | <a href="http://zozu.pl" style="top: 3px; color: #ffffff;">Pełne wsparcie obsługi restauracji
        online.</a>
      </div>
    </div>
  </div>
</template>
<script>
import imageMixin from "@/mixins/imageMixin";
import BackToTop from "@/views/partials/BackToTop";

export default {
  name: 'corporate-footer',
  components: {BackToTop},
  data() {
    return {
      config: window.config
    }
  },
  mixins: [imageMixin],
}
</script>

